// extracted by mini-css-extract-plugin
export default {"imagePreview":"SelectText-imagePreview-ry3","wrapper":"SelectText-wrapper-c6V","action":"SelectText-action-W2_","dropdown":"SelectText-dropdown-v3R"};